export const aboutData = {
    title: "Future aviation engineer!",
    description1: "Hello! I'm Marko and i'm ready to change the world one line of code at a time.",
    description2: "I am a first-year Aviation Engineering student at the Estonian Aviation Academy with an interest in communication and telecommunication systems. Alongside my studies, I enjoy programming and have previously learned full-stack web development independently, as well as Python during my studies.Before starting my studies, I worked for several years as a bicycle mechanic and later as a gaming equipment technician at Olympic Casino, where I was responsible for maintaining and troubleshooting technical systems.",
    

    image: 1
}
